/**
 * The Bahnhof password policy, as DS card 17 (Password strength) states it — shared by
 * BfPasswordStrength, which shows it, and any page that gates a submit on it.
 */
export interface PasswordRule {
  id: string
  label: string
  isMet: (password: string) => boolean
}

export const ALLOWED_PASSWORD_SYMBOLS = '! " # $ % & \' ( ) * + , - . / : ; < = > ? @ [ ] ^ _  { | } ~`'

/** Every symbol the list above advertises, so the rule ticks for all of them. */
const SYMBOL_PATTERN = /[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]/

export const PASSWORD_RULES: PasswordRule[] = [
  { id: 'length', label: '10–20 characters', isMet: password => password.length >= 10 && password.length <= 20 },
  { id: 'lowercase', label: 'Lowercase (a–z)', isMet: password => /[a-z]/.test(password) },
  { id: 'uppercase', label: 'Uppercase (A–Z)', isMet: password => /[A-Z]/.test(password) },
  { id: 'digit', label: 'Number (0–9)', isMet: password => /\d/.test(password) },
  { id: 'symbol', label: 'A special character', isMet: password => SYMBOL_PATTERN.test(password) },
]

export function isPasswordPolicyMet(password: string): boolean {
  return PASSWORD_RULES.every(rule => rule.isMet(password))
}
